<template>
  <div class="table-selector">
    <BaseButton
      class="w-100"
      size="md"
      variant="primary"
      @click="selectHall"
      :color="isHallSelected ? selectedColor : defaultColor"
    >
      {{ section.name }}
    </BaseButton>
    <div class="tables-grid mt-16">
      <div
        class="table-cell"
        @click="selectTable(table, index)"
        :style="getCellStyle(table, index)"
        v-for="(table, index) in section.tables_list"
        :key="index"
      >
        <div class="qrw-label-sm">
          {{ table.name }}
        </div>
        <div class="qrw-paragraph-xs">#{{ index + 1 }}</div>
        <div class="qrw-paragraph-xs" :class="{
          'red-4-color': !table.places_count
        }" v-if="mode == 'reserve'">
          {{ table.places_count || 0 }} {{ $tc('halls_tables.places_count_plural', table.places_count)}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    section: Object,
    section_index: Number,
    mode: {
      type: String,
      default: "reserve",
    },
    attached_tables: Array,
  },
  methods: {
    getCellStyle(table, index) {
      let state = this.isTableSelected(table, index);

      const style = {
        
      };

      if (this.mode == "reserve" && !table.places_count) {
        state = false;
        style.border = `1px solid var(--${this.warningColor}-color)`;
      }

      let color = state ? this.selectedColor : this.defaultColor;

      style['background-color'] = `var(--${color}-color)`;      

      if (state) style.color = 'var(--v1-grey-3-color)';

      return style;
    },
    isTableSelected(table, index) {
      if (this.mode == "reserve") {
        return table.for_reserve;
      }

      if (this.mode == 'waiter') {
        return this.isTableAttached(this.section_index, index+1); 
      }
    },
    selectTable(table, index) {
      if (this.mode == "reserve") {
        if (!table.places_count) return;

        table.for_reserve = !table.for_reserve;

        this.$store.commit("setCafeSection", {
            index: this.section_index,
            value: this.section,
        });

        this.$store.dispatch("saveCafe");
      }

      if (this.mode == 'waiter') {
        this.toggleTableAttachment(this.section_index, index+1);
      }
    },

    selectHall() {
      if (this.mode != 'waiter') return;

      const initially_selected_hall = this.isHallSelected;

      for (let i = 0; i < this.section.tables_list.length; i++) {
        if (!this.isTableAttached(this.section_index, i+1) || initially_selected_hall)  {
          this.toggleTableAttachment(this.section_index, i+1, true);
        }
      }

      this.$emit("saved", this.attached_tables);
    },

    isTableAttached(section_index, table) {
      return !!this.attached_tables.find(
        (o) => o.section == section_index && o.table == table
      );
    },
    toggleTableAttachment(section_index, table, dont_save) {
      const index = this.attached_tables.findIndex(
        (o) => o.section == section_index && o.table == table
      );

      if (index !== -1) {
        this.attached_tables.splice(index, 1);
      } else {
        this.attached_tables.push({
          section: section_index,
          table,
        });
      }

      if (!dont_save) this.$emit("saved", this.attached_tables);
    },
  },
  computed: {
    isHallSelected() {
        if (this.mode == 'waiter') {
            return this.section.tables_list.every((t,i) => this.isTableAttached(this.section_index, i+1));
        }
      return false;
    },
    selectedColor() {
      return "green-6";
    },
    defaultColor() {
      return "v1-grey-4";
    },
    warningColor() {
      return "red-4";
    },
  },
};
</script>

<style scoped>
.table-selector {
}

.tables-grid {
  display: flex;
  gap: 8px;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
}

.table-cell {
  padding: 8px;
  border-radius: 4px;
  text-align: center;
  color: var(--v1-grey-7-color);
  /* width: 95px; */
  /* max-width: 95px; */
  min-height: 28px;
  max-height: 28px;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-flow: column;
  cursor: pointer;

  flex: 0 0 calc(20% - 23px);
}
</style>